import React from "react";
import { Theme } from "@emotion/react";
import { Box, SxProps } from "@mui/material";
import { useStyles } from "./styles";

type MiniCardProps = {
  children?: JSX.Element | JSX.Element[];
  bgColor?: string;
  sx?: SxProps<Theme> | undefined;
  onClick?: any;
};

export default function MiniCard({
  children,
  bgColor,
  sx,
  onClick,
}: MiniCardProps) {
  const classes = useStyles;

  return (
    <Box
      sx={{ ...classes.miniCard, backgroundColor: bgColor, ...sx }}
      onClick={onClick}
    >
      {children}
    </Box>
  );
}
